import vipTypeEnum from '../../data/vipTypeEnum';
import moment from 'moment';

/**
 * @module  util/userUtil
 */

export default {

    /**
     * @param   {Object}  data    user data
     * @return  {Object}
     */
    createUser : function (data = {}) {

        let user = {

            vipDueTime : null,
            vipInfoMap : null,

            /**
             * @method  getVipInfo
             * @return  Object
             */
            getVipInfo : function () {
                if (this.vipInfoMap != null)
                {
                    return this.vipInfoMap;
                }

                if (this.vipDueTime != null)
                {
                    const nullTime    = '0000-00-00 00:00';
                    const nowTime     = moment().format('YYYY-MM-DD HH:mm');
                    this.vipInfoMap = {
                        course_vod : {
                            name : '课程VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.COURSE_VOD] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.COURSE_VOD] || nullTime) >= nowTime
                        },
                        datum : {
                            name : '资料VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.DATUM] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.DATUM] || nullTime) >= nowTime
                        },
                        super : {
                            name : '超级SVIP',
                            dueTime : this.vipDueTime[vipTypeEnum.SUPER] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.SUPER] || nullTime) >= nowTime
                        }
                    }
                }

                return this.vipInfoMap;
            },

            /**
             * get max vip due time from all vip type
             * @method  getVipDueTime
             * @return  {String}
             */
            getVipDueTime : function() {
                const vipList = this.getVipInfo();
                let timeout = '';
                // compute max value
                for (let key in vipList)
                {
                    if (vipList[key].status && vipList[key].dueTime > timeout)
                    {
                        timeout = vipList[key].dueTime;
                    }
                }
                return timeout;
            },

            /**
             * @method  isVip
             * @return {boolean}
             */
            isVip : function () {
                const vipList = this.getVipInfo();
                for (let key in vipList)
                {
                    if (vipList[key].status)
                    {
                        return true;
                    }
                }
                return false;
            },

            /**
             * @method  isVipType
             * @param   {String}  type
             * @return  {Boolean}
             */
            isVipType : function (type) {

                const vipInfoMap = this.getVipInfo();
                if (typeof (vipInfoMap[type]) != 'object')
                {
                    return false;
                }

                return vipInfoMap[type].status;
            },

            /**
             * @method  isContentHasVipPrivilege
             * @param   {String}    contentType     'course_vod'|'datum'
             * @return  {Boolean}
             */
            isContentHasVipPrivilege : function (contentType) {

                const vipInfoMap = this.getVipInfo();

                // SVIP has all privilege
                if (vipInfoMap.super.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                {
                    return true;
                }

                // check normal VIP
                switch (contentType) {
                    case 'course_vod' :
                        if (vipInfoMap.course_vod.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                        {
                            return true;
                        }
                        break;
                    case 'datum' :
                        if (vipInfoMap.datum.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                        {
                            return true;
                        }
                        break;
                }

                return false;

            }

        };

        // init data
        for (let key in data)
        {
            user[key] = data[key];
        }

        return user;
    }

};




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/lib/util/user.js
 **/